import { SelectedLearner, StateType } from "./chatProvider";
import { MESSAGE_ID, Message, MessageIdType } from "./consts";

export const ACTION_TYPES = {
  GO_TO_NEXT_MESSAGE: "GO_TO_NEXT_MESSAGE",
  UPDATE_LEARNER: "UPDATE_LEANER",
  RESET_CONCIERGE_REQUEST: "RESET_CONCIERGE_REQUEST"
} as const;

export type UpdateLearnerAction = {
  type: typeof ACTION_TYPES.UPDATE_LEARNER;
  payload: {
    learner: SelectedLearner;
  };
};
export type GoToNextMessageAction = {
  type: typeof ACTION_TYPES.GO_TO_NEXT_MESSAGE;
  payload: {
    nextMessageId: MessageIdType;
    messages: Message[]; // The messages order matters
  };
};

export type ResetConciergeRequestAction = {
  type: typeof ACTION_TYPES.RESET_CONCIERGE_REQUEST;
};

export type ChatActionType =
  | GoToNextMessageAction
  | UpdateLearnerAction
  | ResetConciergeRequestAction;

export const chatReducer = (
  state: StateType,
  action: ChatActionType
): StateType => {
  switch (action.type) {
    case ACTION_TYPES.GO_TO_NEXT_MESSAGE: {
      const { payload } = action;
      const { nextMessageId, messages } = payload;

      return {
        ...state,
        currentMessageId: nextMessageId,
        conversation: [...state.conversation, ...messages]
      };
    }
    case ACTION_TYPES.UPDATE_LEARNER: {
      const { payload } = action;
      return {
        ...state,
        selectedLearner: payload.learner
      };
    }
    case ACTION_TYPES.RESET_CONCIERGE_REQUEST: {
      return {
        ...state,
        currentMessageId: MESSAGE_ID.CONCIERGE_REQUEST,
        conversation: [],
        selectedLearner: undefined
      };
    }
    default:
      return state;
  }
};
